import React, { CSSProperties, ReactNode } from 'react';

interface BrushHighlightProps {
  children: ReactNode;
  color?: string;
  rotateDeg?: number;
  cap?: boolean;
  capColor?: string;
  className?: string;
  style?: CSSProperties;
}

export function BrushHighlight({
  children,
  color = '#FF4B4B',
  rotateDeg = -2,
  cap = false,
  capColor = '#2A160F',
  className = '',
  style,
}: BrushHighlightProps) {
  // Дуга-маркер (curved arc band behind text) — толстая версия
  const arcPath = `
    M0,6 
    Q120,22 240,6 
    L240,58 
    Q120,74 0,58 
    Z
  `;

  return (
    <span
      className={`relative inline-block ${className}`}
      style={{ padding: '0 6px', ...style }}
    >
      {/* SVG дуга как ФОН текста */}
      <svg
        viewBox="0 0 240 80"
        preserveAspectRatio="none"
        className="absolute pointer-events-none"
        style={{
          transform: `rotate(${rotateDeg}deg)`,
          left: '-6px',
          right: '-6px',
          top: '-4px',
          bottom: '-4px',
          width: 'calc(100% + 12px)',
          height: 'calc(100% + 8px)',
        }}
        aria-hidden="true"
      >
        <path d={arcPath} fill={color} />
      </svg>
      
      {/* Торец справа (тёмный прямоугольник) */}
      {cap && (
        <span
          className="absolute right-[-8px] top-[-2px] bottom-[-2px] w-[6px] rounded-sm pointer-events-none"
          style={{
            backgroundColor: capColor,
            transform: `rotate(${rotateDeg + 8}deg)`,
          }}
          aria-hidden="true"
        />
      )}
      
      {/* Текст поверх дуги */}
      <span className="relative z-10">{children}</span>
    </span>
  );
}
